import { z } from 'zod';
import {
  dateRangeSchema,
  numberRangeSchema,
  paginationFiltersSchema,
  sortFiltersSchema,
} from 'utils/schemas';
import { binaries } from 'types/Common';
import { surveyStatuses, surveyTypes } from './surveys.types';

export const surveysFiltersSchema = z
  .object({
    type: z.enum(surveyTypes).nullable().catch(null),
    status: z.array(z.enum(surveyStatuses)).catch([]),
    publishedAt: dateRangeSchema,
    anonymous: z.enum(binaries).nullable().catch(null),
    hasWebAccess: z.enum(binaries).nullable().catch(null),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);

export const surveyPendingSubmissionsFiltersSchema = z
  .object({
    search: z.string().catch(''),
    employees: z.array(z.string()).catch([]),
    companies: z.array(z.string()).catch([]),
    departments: z.array(z.string()).catch([]),
    teams: z.array(z.string()).catch([]),
    orgStructure: z.array(z.string()).catch([]),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);

export const surveySubmissionsFiltersSchema =
  surveyPendingSubmissionsFiltersSchema.extend({
    completionDate: dateRangeSchema,
    score: numberRangeSchema,
  });
